import {createContext} from "react"
export const EcpProjectsContext = createContext({
    ecpProjectsContext: null,
    setEcpProjectsAction: () => {},
})